<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="d-sm-flex align-items-center">
        <router-link
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          to="/addhistorique">
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
          Ajouter un historique
        </router-link>
      </div>
      <div class="d-flex align-items-center">
        <form class="search-box position-relative me-15" @submit.prevent="rechercher">
          <input type="text" v-model="searchTerm" @keyup="rechercher"
            class="form-control shadow-none text-black rounded-0 border-0" placeholder="Rechercher un historique" />
          <button type="submit" class="bg-transparent text-primary transition p-0 border-0">
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                urlImage
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Description
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text pe-0">
                ACTIONS
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(historique, index) in historiques" :key="index">

              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <img :src="getUrlApiForFilesHistorique(historique.urlImage)" alt="Image" width="60" height="60"
                  v-if="historique.urlImage" />
                <span v-else>Aucune image</span>
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis description-cell ">
                {{
                  historique.description
                }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary text pe-0">
                <div class="dropdown">
                  <span class="badge text-white bg-primary fs-15 dropdown-toggle" data-bs-toggle="dropdown"
                    aria-expanded="false">
                    Actions
                    <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                  </span>
                  <ul class="dropdown-menu">
                    <li>
                      <router-link :to="{
                        name: 'EditHistoriquePage',
                        params: { id: historique.id },
                      }" class="dropdown-item d-flex align-items-center">
                        <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
                        Modifier
                      </router-link>
                    </li>
                    <li>
                      <a class="dropdown-item d-flex align-items-center" href="#"
                        @click="deleteHistorique(historique.id)">
                        <i class="flaticon-delete lh-1 me-8 position-relative top-1"></i>
                        Supprimer
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center"
      >
        <PaginationComponent
          :page="page"
          :totalPages="totalPages"
          :totalElements="totalElements"
          :limit="limit"
          @paginate="handlePaginate"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import Swal from "sweetalert2";
import ApiService from "../../services/ApiService";
import {
  suppression,
  error,
  getUrlApiForFiles,
  success,
  getUrlApiForFilesHistorique,
} from "../../utils/utils";
import PaginationComponent from "../../components/Utilities/Pagination.vue";

export default defineComponent({
  name: "ListeHistorique",
  components: {
    PaginationComponent,
  },
  setup() {
    onMounted(() => {
      getAllHistorique();
    });

    const historiques = ref<Array<any>>([]);

    // BEGIN PAGINATE
    const searchTerm = ref("");
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);

    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        getAllHistorique(page_, limit_);
      } catch (error) {
        //
      }
    };

    // END PAGINATE

    function rechercher() {
      getAllHistorique(page.value, limit.value, searchTerm.value);
    }

    function getAllHistorique(page = 1, limi = 10, searchTerm = "") {
      return ApiService.get(
        `/historiques?page=${page}&limit=${limi}&mot=${searchTerm}&`
      )
        .then(({ data }) => {

          historiques.value = data.data.data;
          console.log("historique", data.data.data)
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
          return data.data;
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    }

    const deleteHistorique = (id: number) => {
      Swal.fire({
        title: "Êtes-vous sûr?",
        text: "Vous ne pourrez pas revenir en arrière!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprimer!",
        cancelButtonText: "Annuler"
      }).then((result) => {
        if (result.isConfirmed) {
          ApiService.delete(`/historique/${id}`)
            .then(({ data }) => {
              success(data.message);
              // Retirer l'élément de la liste
              for (let i = 0; i < historiques.value.length; i++) {
                if (historiques.value[i].id === id) {
                  historiques.value.splice(i, 1);
                }
              }
            })
            .catch(({ response }) => {
              error(response.data.message);
            });
        }
      });
    };

    const formatDate = (dateString: string) => {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('fr-FR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    };

    return {
      historiques,
      searchTerm,
      page,
      totalPages,
      totalElements,
      limit,
      handlePaginate,
      rechercher,
      getAllHistorique,
      deleteHistorique,
      getUrlApiForFilesHistorique,
      formatDate,
    };
  },
});
</script>

<style scoped>
.description-cell {
  white-space: normal !important;
  word-break: break-word;
}
</style>